module.exports = __webpack_public_path__ + "static/media/pressure-monitor-offline.ef40dda9.svg";